import { createFileRoute } from '@tanstack/react-router';
import { LedgerAccountDetailPage } from './LedgerAccountDetailPage';
import { z } from 'zod';

const searchSchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().positive().int().optional().default(25),
});

export const Route = createFileRoute(
  '/_protected/admin/internal-tools/ledger/accounts/$accountId/',
)({
  component: LedgerAccountDetailPage,
  validateSearch: searchSchema,
});
